import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { auditApi } from '../api/auditApi';
import type { AuditFilters } from '../types';

export const useAuditLogs = (filters: AuditFilters) =>
  useQuery({
    queryKey: ['audit-logs', filters],
    queryFn: () => auditApi.list(filters),
    staleTime: 30 * 1000,
    placeholderData: keepPreviousData,
  });

export const useAuditFacets = () =>
  useQuery({
    queryKey: ['audit-logs', 'facets'],
    queryFn: auditApi.facets,
    staleTime: 5 * 60 * 1000,
  });
